import { ORDER_TYPE } from 'const/trade'

export default {
  data() {
    return {
      orderIdsMap: {} // 主订单下的附加订单id
    }
  },
  computed: {
    orderMap() {
      const map = {}
      const showOrders = this.filterShowOrders(this.curStockOrders)

      showOrders.forEach(order => {
        const { limitPrice, auxPrice } = order
        const { latestPrice = 0 } = this.priceMap
        switch (order.orderType) {
          case ORDER_TYPE.LMT:
            // 附加订单PROFIT按LMT
            map[limitPrice] = this.setOrderCount(order, map[limitPrice])
            break
          case ORDER_TYPE.MKT:
            map[latestPrice] = this.setOrderCount(order, map[latestPrice])
            break
          case ORDER_TYPE.STP:
          case ORDER_TYPE.STP_LMT:
            // 附加订单LOSS按STP
            map[auxPrice] = this.setOrderCount(order, map[auxPrice])
            break
        }
      })
      return map
    }
  },
  methods: {
    filterShowOrders(orders = []) {
      // 模拟账号没有附加订单不需要单独处理
      if (this.isVirtual) {
        return orders
      }
      const orderIdsMap = {}
      // 过滤订单，主订单未成交不显示附加订单
      const mainOrders = orders
        .map(order => {
          if (order.attachType === ORDER_TYPE.MAIN) {
            return order.orderId
          }
          if (order.parentId) {
            if (!orderIdsMap[order.parentId]) {
              orderIdsMap[order.parentId] = [order.orderId]
            } else {
              orderIdsMap[order.parentId].push(order.orderId)
            }
          }
        })
        .filter(Boolean)

      this.orderIdsMap = orderIdsMap

      // 订单的主订单id还在说明没成交
      const ret = orders
        .map(order => {
          if (!mainOrders.includes(order.parentId)) {
            return order
          }
        })
        .filter(Boolean)
      return ret
    },
    // 订单价格和股数映射表
    setOrderCount(order, res) {
      const { action, totalQuantity, orderId, id } = order
      const type = action === 'BUY' ? 'bid' : 'ask'
      if (!res) {
        res = {
          ask: 0,
          askOrders: [],
          bid: 0,
          bidOrders: [],
          order: order
        }
      }
      res[type] += totalQuantity
      res[`${type}Orders`].push(orderId || id)
      // 主订单撤销，附加订单需要一起撤销
      const attachIds = this.orderIdsMap[orderId]
      if (attachIds) {
        res[`${type}Orders`] = res[`${type}Orders`].concat(attachIds)
      }
      return res
    }
  }
}
